import { render, staticRenderFns } from "./operatorMerchants.vue?vue&type=template&id=2522927f&scoped=true&"
import script from "./operatorMerchants.vue?vue&type=script&lang=js&"
export * from "./operatorMerchants.vue?vue&type=script&lang=js&"
import style0 from "./operatorMerchants.vue?vue&type=style&index=0&id=2522927f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2522927f",
  null
  
)

export default component.exports